import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import moment from "moment";

import "./style.css";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import StudentAppBar from "../StudentAppBar";
import Paging from "../Paging";
import StudentSideBar from "../StudentSideBar";

import AdmissionApi from "../../Services/AdmissionApi";

class Favourites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: window.innerWidth < 980 ? false : true,
      scholarship: [],
      alerts: [],
      alertsAll: [],
      showLoading: true,
      name: "",
      sponsoring_institution: "",
      amount_from: "",
      amount_to: "",
      pageS: 1,
      pageA: 1,
      pageSize: 6,
      totalPagesS: 1,
      totalPagesA: 1,
      passingYear: '',
    };

    this.admissionsService = new AdmissionApi();
  }

  updateStateA = (response) => {
    this.setState({
      alerts: response.data._embedded.admissionalerts,
      showLoading: false,
      pageA: response.data.page,
      totalPagesA: response.data.pageCount,
    });
  };

  updateStateS = (newOwner) => {
    this.setState({
      scholarship: newOwner.data._embedded.scholarships,
      showLoading: false,
      totalPagesS: newOwner.data.pageCount,
    });
  };

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  componentDidMount() {
    const isLogin = localStorage.getItem("isLogin")

    if (isLogin == 1) {
      this.getStudentBatch()
      this.getFavScholarshipAlerts()
    } else {
      this.context.router.push("/signIn")
    }
  }

  cbUserInfo = (newResponse) => {
    if (!newResponse.data.success) return

    const student = newResponse.data._embedded.students[0]
    if (student) {
      this.setState({
        passingYear: student.batch,
      })
      setTimeout(() => this.getFavAdmnAlerts(), 300)
    }

  }

  getStudentBatch = () => {
    const userId = localStorage.getItem("userId")

    this.admissionsService.GetData(
      this.cbUserInfo,
      "v1/students?user_id=" + userId
    )
  }

  getFavAdmnAlerts = (page = 1) => {
    const _userCategories = JSON.parse(localStorage.getItem('categories'))
    const userCategories = _userCategories.reduce((res, item) => [...res, item.value], [])
    const { passingYear } = this.state
    let filters = ''
    if (passingYear) filters += `&year_of_passing=${passingYear}`
    this.admissionsService.GetData(
      this.updateStateA,
      `v1/alerts/admissionalerts?page=${page}&pageSize=${this.state.pageSize}&column=created_at&order=desc&course_category_id=${userCategories}&userId=${localStorage.getItem('userId')}&userRole=student&isFavourite=true${filters}`
    );
  }

  getFavScholarshipAlerts = (page = 1) => {
    this.admissionsService.GetData(
      this.updateStateS,
      `v1/alerts/scholarships?page=${page}&pageSize=${this.state.pageSize}&column=created_at&order=desc&userId=${localStorage.getItem('userId')}&userRole=student&isFavourite=true`
    );
  }

  getInfo = () => {
    this.admissionsService.GetData(
      this.updateState,
      "v1/alerts/scholarships?name=" +
      this.state.name +
      "&sponsoring_institution=" +
      this.state.sponsoring_institution +
      "&amount_from=" +
      this.state.amount_from +
      "&amount_to=" +
      this.state.amount_to
    );
  }

  getCourse = (data) => {
    let _data = JSON.parse(data);
    return Object.values(_data);
  }

  handlePageChangeA = (page) => {
    this.getFavAdmnAlerts(page)
    this.setState({ pageS: page });
  }

  handlePageChangeS = (page) => {
    this.getFavScholarshipAlerts(page)
    this.setState({ pageS: page });
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {
    const {
      pageS,
      pageA,
      totalPagesS,
      totalPagesA,
      scholarship,
      alerts,
      isOpen
    } = this.state

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="My Favourites" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">

              {/* Admission Fav */}

              <section className="dash-alerts">
                <h2>Admission Alerts</h2>
                <table className="table table-responsive alert-table">
                  <thead>
                    <tr>
                      <th scope="col">Institution</th>
                      <th scope="col">Last date to apply</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {alerts.map(item => (
                      <tr key={item.id}>
                        <td>
                          <p className="m-0">{item.institution_name}</p>
                          {this.getCourse(item.course_category_id).map((item, i) => {
                            const _userCategories = JSON.parse(localStorage.getItem('categories'))
                            const userCategories = _userCategories.reduce((res, item) => [...res, item.label], [])
                            return (
                              <span
                                key={i}
                                className="badge mr-2 mb-1"
                                style={{ backgroundColor: `hsl(${300 + i * 50}deg 36% 84%)`, display: !userCategories.includes(item) ? 'none' : null }}
                              >
                                {item}
                              </span>
                            )
                          })}
                        </td>
                        <td>{item.last_date_online}</td>
                        <td>
                          <Link to={{ pathname: "/alertDetail", state: { data: item } }} className="alert-table__link">details</Link>
                        </td>
                      </tr>
                    ))}
                    {!alerts.length && (
                      <tr>
                        <td colSpan={2}>You haven't added any admission alert as favourite</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <Paging page={pageA} totalPages={totalPagesA} onChange={this.handlePageChangeA} />
              </section>

              <hr />

              {/* Scholarship Fav */}
              <section className="dash-alerts">
                <h2>Scholarship Alerts</h2>
                <table className="table table-responsive alert-table">
                  <thead>
                    <tr>
                      <th scope="col">Scholarship Name</th>
                      <th scope="col">Sponsoring Institution</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Last Date to Apply</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {scholarship.map(item => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.sponsoring_institution}</td>
                        <td>{item.amount}</td>
                        <td>{moment(item.scholarship_last_date).format('DD/MM/YYYY')}</td>
                        <td>
                          <Link to={{ pathname: "/scholarshipDetail", state: { data: item } }} className="alert-table__link">details</Link>
                        </td>
                      </tr>
                    ))}
                    {!scholarship.length && (
                      <tr>
                        <td colSpan={2}>You haven't added any scholarship as favourite</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <Paging page={pageS} totalPages={totalPagesS} onChange={this.handlePageChangeS} />
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default Favourites;



/** WEBPACK FOOTER **
 ** ./src/components/Favourites/index.js
 **/